// extracted by mini-css-extract-plugin
module.exports = {"actions":"Actions_actions__1XBxk","action":"Actions_action__1FyGm","button":"Actions_button__1N6Cs","icon":"Actions_icon__cSLvE"};